<template>
  
</template>

<script>
 import md5 from 'js-md5';
 import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: 'DevicePoC22',
  props: {
    
  },
  data(){
    return { 

    }
  },
  methods:{
    getAddUserRecords(formData) {
      console.log('DevicePoC22 getAddUserRecords');
      console.log('formData:', formData);      

      const { returnObj, checkboxMap } = formData;

      const serviceProfileInfoFlag = checkboxMap['serviceProfileInfo'];

      if(formData.opCode !== 'batchMod' || (formData.opCode === 'batchMod' && serviceProfileInfoFlag)) {
        if(returnObj['regclass'] === 0){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.regClassNeeded')});
          return null;
        }
      }
      
      returnObj['vpnid'] = formData.vpnid;

      if(formData.username) {
        returnObj['username'] = formData.username;
      }

      returnObj['createtime'] = Math.round(new Date() / 1000);

      if(returnObj['invalidtime']) {
        const invalidtime = new Date(returnObj['invalidtime'].replace(/-/g,'/')).getTime() / 1000;
        returnObj['invalidtime'] = invalidtime;
      }

      returnObj['autiocallcapability']  = 0;
      returnObj['sercuritycapability']  = 0;
      returnObj['videocallcapability']  = 0;      
      returnObj['bitmask']              = 1;

      returnObj['subid']                = returnObj['impu'];
      returnObj['serviceprofileid']     = returnObj['impu'];

      returnObj['regstatus']     = returnObj['regstatus'].toString();
      returnObj['rtttype']       = returnObj['rtttype'].toString();
      returnObj['substatus']     = returnObj['substatus'].toString();
      returnObj['terminalType']  = '0';
      returnObj['userenable']    = returnObj['userenable'].toString();
      returnObj['userForbidden'] = returnObj['userenable']; 

      let voiceClassName         = 'voiceClass';
      let dataClassName          = 'dataClass';
      let mediaClassName         = 'mediaClass';
      let otherClassName         = 'otherClass';

      let voicestror = "000000000"+returnObj[voiceClassName].toString(2);
      let datastror  = "0000"+returnObj[dataClassName].toString(2);
      let mediastror = "0000000000000000"+returnObj[mediaClassName].toString(2);
      let otherstror = "00000000000000000"+returnObj[otherClassName].toString(2);

      let voicestr = voicestror.split('').reverse().join('');
      let datastr  = datastror.split('').reverse().join('');
      let mediastr = mediastror.split('').reverse().join('');
      let otherstr = otherstror.split('').reverse().join('');

      let voice = voicestr.charAt(0)+voicestr.charAt(1)+voicestr.charAt(2);
      let data  = datastr.charAt(0)+datastr.charAt(1)+datastr.charAt(2)+datastr.charAt(3)+mediastr.charAt(14)+mediastr.charAt(15);
      let media = mediastr.charAt(0)+mediastr.charAt(1)+mediastr.charAt(2)+mediastr.charAt(3)+mediastr.charAt(4)+mediastr.charAt(5)+mediastr.charAt(6)+mediastr.charAt(7)+mediastr.charAt(8)+mediastr.charAt(9)+mediastr.charAt(10)+mediastr.charAt(11);
      let other = voicestr.charAt(3)+voicestr.charAt(4)+otherstr.charAt(0)+otherstr.charAt(1)+'0'+otherstr.charAt(2)+otherstr.charAt(3)+otherstr.charAt(4)+otherstr.charAt(5)+otherstr.charAt(6)+voicestr.charAt(5)+otherstr.charAt(7)+otherstr.charAt(8)+voicestr.charAt(6)+
        voicestr.charAt(7)+mediastr.charAt(12)+otherstr.charAt(9)+otherstr.charAt(10)+otherstr.charAt(11)+voicestr.charAt(8)+mediastr.charAt(13)+otherstr.charAt(12)+otherstr.charAt(13)+otherstr.charAt(14)+otherstr.charAt(15);

      returnObj[voiceClassName] = parseInt(voice.split('').reverse().join(''),2);
      returnObj[dataClassName]  = parseInt(data.split('').reverse().join(''),2);
      returnObj[mediaClassName] = parseInt(media.split('').reverse().join(''),2);
      returnObj[otherClassName] = parseInt(other.split('').reverse().join(''),2);

      if(formData.opCode ==='mod')
      {
        if(formData.passwordbefore != returnObj['password[confirm]'] || formData.realmbefore != returnObj['realm'] || formData.lteimsibefore != returnObj['lteimsi'])
        {
          if(returnObj['lteimsi']!=='')
            returnObj['password'] = md5(returnObj['impu']+':'+returnObj['realm'].replace('@','')+':'+returnObj['password[confirm]']+':'+returnObj['lteimsi']);
          else
            returnObj['password'] = md5(returnObj['impu']+':'+returnObj['realm'].replace('@','')+':'+returnObj['password[confirm]']);
        }
        else
        {
          returnObj['password'] = formData.passwordbefore;
        }
      }
      if(formData.opCode ==='add' || formData.opCode ==='mod') {
        returnObj.opCount = 1;
      }
 
      return returnObj;
    },
    async getModUserRecords(param, recordData) {
      console.log('DevicePoC22 getModUserRecords');
      console.log('param:', param);
      console.log('recordData:', recordData);

      const reqParam = {
        vo: {
          flag: 1,  
        },
        info: {
          msgid: '27816',
          neid: param.neid
        },
        page: {
          pageNo: 1,
          pageSize: 100,
          totalCount: 0,
          pageCount: 0,
        },
      };
      
      const impuObj = JSON.parse(JSON.stringify(recordData));
      console.log('impuObj:', impuObj);

      reqParam.vo.serviceprofileid = impuObj['impu']; 
      console.log('reqParam:', reqParam);

      let serviceprofile = null; 
      await this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', reqParam).then((response) => {
        const res = response.data.resultVal;
        if (res && res.result === 0) {
          serviceprofile = res.resultList[0];
        }
        console.log('serviceprofile:', serviceprofile);
      }).catch((error) => {
        console.log('error', error);
      });

      reqParam.vo.subid = impuObj['subid'];
      reqParam.info.msgid = '27801';

      let tsub = null;
      await this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', reqParam).then((response) => { 
        const res = response.data.resultVal;
        if (res && res.result === 0) {
          tsub = res.resultList[0];
        }
        console.log('tsub:', tsub);  
      }).catch((error) => {
        console.log('error', error);
      });

      const record = {
        ...impuObj,
        ...serviceprofile,
        ...tsub,
      };
      
      let voiceClassName      = 'voiceClass';
      let dataClassName       = 'dataClass';
      let mediaClassName      = 'mediaClass';
      let otherClassName      = 'otherClass';

      let voicestror = "000"+record[voiceClassName].toString(2);
      let datastror  = "000000"+record[dataClassName].toString(2);
      let mediastror = "000000000000"+record[mediaClassName].toString(2);
      let otherstror = "0000000000000000000000000"+record[otherClassName].toString(2);

      voicestror = voicestror.substring(voicestror.length-3);
      datastror = datastror.substring(datastror.length-6);
      mediastror = mediastror.substring(mediastror.length-12);
      otherstror = otherstror.substring(otherstror.length-25);

      let voicestr = voicestror.split('').reverse().join('');
      let datastr = datastror.split('').reverse().join('');
      let mediastr = mediastror.split('').reverse().join('');
      let otherstr = otherstror.split('').reverse().join('');

      let voice=[];
      let data=[];
      let media=[];
      let other=[];
      voice[0] = voicestr.charAt(0);
      voice[1] = voicestr.charAt(1);
      voice[2] = voicestr.charAt(2);

      data[0] = datastr.charAt(0);
      data[1] = datastr.charAt(1);
      data[2] = datastr.charAt(2);
      data[3] = datastr.charAt(3);
      media[14] = datastr.charAt(4);
      media[15] = datastr.charAt(5);

      media[0] = mediastr.charAt(0);
      media[1] = mediastr.charAt(1);
      media[2] = mediastr.charAt(2);
      media[3] = mediastr.charAt(3);
      media[4] = mediastr.charAt(4);
      media[5] = mediastr.charAt(5);
      media[6] = mediastr.charAt(6);
      media[7] = mediastr.charAt(7);
      media[8] = mediastr.charAt(8);
      media[9] = mediastr.charAt(9);
      media[10] = mediastr.charAt(10);
      media[11] = mediastr.charAt(11);

      voice[3] = otherstr.charAt(0);
      voice[4] = otherstr.charAt(1);
      other[0] = otherstr.charAt(2);
      other[1] = otherstr.charAt(3);
      other[2] = otherstr.charAt(5);
      other[3] = otherstr.charAt(6);
      other[4] = otherstr.charAt(7);
      other[5] = otherstr.charAt(8);
      other[6] = otherstr.charAt(9);
      voice[5] = otherstr.charAt(10);
      other[7] = otherstr.charAt(11);
      other[8] = otherstr.charAt(12);
      voice[6] = otherstr.charAt(13);
      voice[7] = otherstr.charAt(14);
      media[12] = otherstr.charAt(15);
      other[9] = otherstr.charAt(16);
      other[10] = otherstr.charAt(17);
      other[11] = otherstr.charAt(18);
      voice[8] = otherstr.charAt(19);
      media[13] = otherstr.charAt(20);
      other[12] = otherstr.charAt(21);
      other[13] = otherstr.charAt(22);
      other[14] = otherstr.charAt(23);
      other[15] = otherstr.charAt(24);

      let voiceclass ='';
      voice.forEach( item => {
        voiceclass = voiceclass + item;
      });
      let dataclass ='';
      data.forEach( item => {
        dataclass =dataclass+item;
      });
      let mediaclass ='';
      media.forEach( item => {
        mediaclass = mediaclass + item;
      });
      let otherclass ='';
      other.forEach( item => {
        otherclass = otherclass + item;
      });

      record[voiceClassName] = parseInt(voiceclass.split('').reverse().join(''),2);
      record[dataClassName] = parseInt(dataclass.split('').reverse().join(''),2);
      record[mediaClassName] = parseInt(mediaclass.split('').reverse().join(''),2);
      record[otherClassName] = parseInt(otherclass.split('').reverse().join(''),2);

      record['password[origin]'] = record['password'];
      record['password[confirm]'] = record['password'];

      if(record['invalidtime'] == '0') {
        record['invalidtime'] = null;
      } else if (record['invalidtime']) {
        const invalidtime = new Date(parseInt(record['invalidtime'], 10) * 1000); 
        record['invalidtime'] = invalidtime;
      }
      return record; 
    },
    getQryUserRecords(param) {
      console.log('DevicePoC22 getQryUserRecords:',param);
      // nothing to do
      return null;
    },
    getDelUserRecords(param) {
      console.log('DevicePoC22 getDelUserRecords:',param);

      const { userid, info } = param;
       
      const users = [];
      const resultObj = [];

      for (let i = 0; i < userid.length; i++) {
        users.push({ 
          impu: userid[i].impu, 
          impi: userid[i].impi, 
          realm: userid[i].realm, 
        });
        resultObj[i] = { operObj: userid[i].impu };
      }

      const logParam = {
        module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
        execFunName:'subscriber.delUser',
        exectype:3,
        execData:users
      }; 

      const paramMap = {};

      paramMap.vo   = { opCount: users.length, list: users };
      paramMap.log  = logParam;
      paramMap.info = info;

      return { paramMap, resultObj };
    },

    async getBatchModUserRecords(param, recordData) {
      console.log('DevicePoC22 getBatchModUserRecords:',param,recordData);

      const recordDataNew = await Promise.all(recordData.map(async (item)=>{
        return (async ()=>{
          
          // 注意, 这个函数是并发, 尽量不要使用函数外部的对象
          const reqParam = {
            vo: {
              flag: 1,            //flag=0 查询所有  flag=1精确查询  flag=2模糊查询          
            },
            info: {
              msgid: '',
              neid: param.info.neid,
            },
            page: {
              pageNo: 1,
              pageSize: 100,
              totalCount: 0,
              pageCount: 0,
            },
          };          
          reqParam.info.msgid = '27816';
          reqParam.vo.serviceprofileid = item.serviceprofileid;

          let serviceprofile = null; 
          await this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', reqParam).then((response) => {
            const res = response.data.resultVal;
            if (res && res.result === 0) {
              serviceprofile = res.resultList[0];
            }
          }).catch((error) => {
            console.log('error', error);
          });
          reqParam.info.msgid = '27801';
          reqParam.vo.subid = item.subid;

          let tsub = null;
          await this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', reqParam).then((response) => { 
            const res = response.data.resultVal;
            if (res && res.result === 0) {
              tsub = res.resultList[0];
            }
            console.log('tsub:', tsub);  
          }).catch((error) => {
            console.log('error', error);
          });
          return {
            ...item,
            ...serviceprofile,
            ...tsub,
          };
        })();
      }));
      console.log('recordDataNew:', recordDataNew);
      return recordDataNew;     
    },
  },
  components:{
    
  }
}
</script>